//import Vue from 'vue'
import Vue from 'vue/dist/vue.js'
import firebase from 'firebase'
import { storage } from '../firebase'
import moment from 'moment'
import VoiceMessageListener from './voiceMessageListener'
import { mapGetters } from 'vuex'
import { store } from '../store/store'

export const popupVue = new Vue({
    store,
    data() {
        return {
          audioKey: null,
          listenImg: require('../img/ic_listen.svg'),
          soundImg: require('../img/soundtest_green.svg'),
          cancelImg: require('../img/cancel.svg'),
          pep: null,
          pepKey: null,
          popup: null,
          vml: new VoiceMessageListener()
        }
      },
      computed: {
        ...mapGetters(['currentRaceId']),
        sender () {
          var sender = ''
            if(this.pep.runnerPoint) {
              sender = 'Your point'
            } else {
              sender = this.pep.messagetype === 'A' ? 'Audio' : this.pep.sender
            }

          return sender
        }
      },
      mounted() {
        console.log("popup vue mounted")
      },
      methods: {
          cancel() {
            try {
              this.vml.clearVml()
              if(this.popup) {
                this.popup.remove()
              }
            } catch(err) {
              console.log(err)
            }
          },
          setupMessages(messages) {
            console.log("setting up popup audio messages")
            console.log(messages)
            this.vml.setUpMessages(messages)
          },
      },
      //template: require('./popup.html')
      template: `
      <div class="popup" v-if="pep">
        <div class="myRaces-popup">
          <div class="top-row">
            <div class="sender-container">
              <label class="myRaces-sender">{{sender}}</label>
            </div>
            <img v-on:click="cancel()" :src="cancelImg"/>
          </div>

          <div class="popup-content">
            <div class="popup-audio-content" v-if="pep.messagetype === 'A'">
                <div v-if="vml.messages[pepKey]">
                  <img v-if="vml.messages[pepKey].listening" :src="soundImg" />
                  <div v-else-if="vml.messages[pepKey].loaded === false" class="loader" style="padding: 7px; margin-top: 0px; width: 8px; height: 8px"></div>
                  <img v-else :src="listenImg" style="width:20px; height: 20px; margin-left: 3px;" v-on:click="vml.playAudio(pepKey, pep.message, currentRaceId)"/>
                  </div>
                  <label class="download-button" v-on:click="vml.downloadAudio(pepKey, pep.message, currentRaceId)">Download</label>

            </div>

            <div class="popup-message-content" v-else >
              <textarea row=3 disabled>{{pep.message}}</textarea>
            </div>
          </div>

        </div>
      </div>
      `
  })
  //}).$mount()
